import React from 'react'
import PropTypes from 'prop-types'

export default class FileUploader extends React.Component {
  state = {
    loading: false
  }

  handleImageChosen = (e) => {
    if(this.imageFieldRef.files[0]) {
      this.performUpload()
    }
    else {
      onChange({ id: null, url: null, rawUrl: null, filename: null })
    }
  }

  performUpload = () => {
    const { apiKey, host, onChange } = this.props

    const fullUrl = host ? `${host}/api/v1/embedded_attachments` : "/api/v1/embedded_attachments"

    this.setState({ loading: true })

    const form = new FormData
    form.append('attachment', this.imageFieldRef.files[0])
    const xhr = new XMLHttpRequest;
    xhr.open("POST", fullUrl, true);
    xhr.setRequestHeader("API_KEY", apiKey)

    xhr.onload = () => {
      if(xhr.status === 200) {
        const parsedResponse = JSON.parse(xhr.responseText)
        const id = parsedResponse["data"]["id"]
        const url = parsedResponse["data"]["attributes"]["url"]
        const rawUrl = parsedResponse["data"]["attributes"]["raw_url"]
        const filename = parsedResponse["data"]["attributes"]["filename"]
        this.setState({ loading: false })
        this.imageFieldRef.value = null
        onChange({ id, url, rawUrl, filename })
      }
      else {
        alert("Unable to upload file")
        console.warn("Unable to upload file")
        this.setState({ loading: false })
        this.imageFieldRef.value = null
        onChange({ id: null, url: null, rawUrl: null, filename: null })
      }
    }

    xhr.onerror = () => {
      alert("Unable to upload file")
      console.warn("Unable to upload file")
      this.setState({ loading: false })
      this.imageFieldRef.value = null
      onChange({ id: null, url: null, rawUrl: null, filename: null })
    }

    xhr.send(form)
  }

  render() {
    const { apiKey, host, disabled, acceptedFormats } = this.props
    const { loading } = this.state

    return (
      <div style={{display: "flex", flexDirection: "row"}}>
        <input
          type="file"
          ref={ref => this.imageFieldRef = ref}
          onChange={this.handleImageChosen}
          disabled={disabled || loading}
          accept={acceptedFormats}
        />
        { loading && 
          <div>
            <i className="fa fa-spinner fa-spin fa-fw" />
            <span>Uploading...</span>
          </div>
        }
      </div>
    )

  }
}
